import styled from 'styled-components'

// The design's display face. Lemonade loads it globally but has no token for it,
// so it's named directly (as cause-dashboard's ClaimPage does).
export const DISPLAY_FONT = `'PPRightGroteskMedium', sans-serif`

// Rendered inside a Lemonade Heading, so only the face changes.
export const SectionTitle = styled.span`
  font-family: ${DISPLAY_FONT};
`
